import { getRewardSettingsApi, updateRewardSettingsApi, addRewardSettingsApi, updateRewardSettingsStatusApi, getReferralLevelsApi } from "../components/constant/Api";
import { myApi } from "./api";

export const rewardSettingsApi = myApi.injectEndpoints({
    endpoints: (builder) => ({

        getReferralLevels: builder.query({
            query: (reward_settings_id) => {
                return {
                    url: `${getReferralLevelsApi}?reward_settings_id=${reward_settings_id}`,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => {
                return response.status ? response : { data: [], total: 0 };
            },
            providesTags: (_) => ["rewardSettings"],
        }),
        getRewardSettings: builder.query({
            query: () => {
                return {
                    url: getRewardSettingsApi,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => {
                return response.status ? response : { data: [], total: 0 };
            },
            providesTags: (_) => ["rewardSettings"],
        }),
        updateRewardSettings: builder.mutation({
            query: (post) => ({
                url: updateRewardSettingsApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["rewardSettings"],
        }),
        updateRewardSettingsStatus: builder.mutation({
            query: (post) => ({
                url: updateRewardSettingsStatusApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["rewardSettings"],
        }),
        addRewardSettings: builder.mutation({
            query: (post) => ({
                url: addRewardSettingsApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["rewardSettings"],
        }),
    }),
});

export const { useGetRewardSettingsQuery, useUpdateRewardSettingsMutation, useUpdateRewardSettingsStatusMutation, useAddRewardSettingsMutation, useGetReferralLevelsQuery, useLazyGetReferralLevelsQuery } = rewardSettingsApi;

